import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './common/SafeIcon';
import './App.css';

const { 
  FiPlay, FiCheck, FiStar, FiUsers, FiTrendingUp, FiTarget, 
  FiClock, FiGift, FiShield, FiPhone, FiMail, FiChevronDown,
  FiArrowRight, FiZap, FiDollarSign, FiBookOpen, FiAward, FiX, FiCalendar
} = FiIcons;

function App() {
  // Evergreen timer that resets every 15 minutes
  const [bonusTimeLeft, setBonusTimeLeft] = useState({
    minutes: 14,
    seconds: 59
  });
  const [seatsLeft] = useState(47);
  const [openFaq, setOpenFaq] = useState(null);

  useEffect(() => {
    const timer = setInterval(() => {
      setBonusTimeLeft(prev => {
        if (prev.seconds > 0) {
          return { ...prev, seconds: prev.seconds - 1 };
        } else if (prev.minutes > 0) {
          return { minutes: prev.minutes - 1, seconds: 59 };
        } else {
          // Reset to 15 minutes when timer reaches zero
          return { minutes: 14, seconds: 59 };
        }
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const testimonials = [
    {
      name: "Priya Selvam",
      role: "College Professor",
      result: "21+ Lakhs Revenue",
      period: "10 Months",
      quote: "Abdul sir-ன் workshop attend பண்ணின பிறகு என் online course business-ல 21+ lakhs generate பண்ணினேன். Tamil-ல explain பண்ணினதால் எல்லாமே clear-ஆ புரிஞ்சது!",
      rating: 5
    },
    {
      name: "Rajesh Kumar",
      role: "Digital Coach",
      result: "₹3.8 Lakhs",
      period: "60 Days",
      quote: "1000+ paid members get பண்ணி ₹3.8 lakhs earn பண்ணினேன். AI tools use பண்ணி automated funnel setup பண்ணிட்டேன். Mind-blowing results!",
      rating: 5
    },
    {
      name: "Meera Krishnan",
      role: "Freelancer",
      result: "5,999 Course Sold",
      period: "One Day",
      quote: "One day-ல 19 clients-க்கு ₹5,999 course sell பண்ணினேன். AI automation-ன் power தெரியாம இருந்தேன். Now I'm completely transformed!",
      rating: 5
    }
  ];

  const bonuses = [
    {
      title: "IncomeDone Community Access",
      value: "₹10,000+",
      description: "Lifetime access to exclusive Tamil entrepreneur community",
      icon: FiUsers
    },
    {
      title: "Digital Products Mastery",
      value: "₹4,999",
      description: "Complete course on creating & selling digital products",
      icon: FiBookOpen
    },
    {
      title: "AI Tools Setup Checklist",
      value: "₹2,999",
      description: "Step-by-step setup guide for 25+ AI tools",
      icon: FiCheck
    },
    {
      title: "30-Day Marketing Calendar",
      value: "₹1,999",
      description: "Ready-made content calendar with AI prompts",
      icon: FiTarget
    }
  ];

  const faqs = [
    {
      question: "Workshop எந்த language-ல நடக்கும்?",
      answer: "முழுவதுமாக Tamil-ல தான் நடக்கும். AI tools-ன் technical terms மட்டும் English-ல இருக்கும், ஆனால் எல்லாமே Tamil-ல explain பண்ணுவோம்."
    },
    {
      question: "Beginner-க்கு புரியுமா?",
      answer: "Absolutely! Zero technical knowledge இருந்தாலும் புரியும். Step-by-step-ஆ எல்லாமே teach பண்ணுவோம். AI-ன்னா என்னன்னு கூட தெரியாதவங்க கூட attend பண்ணலாம்."
    },
    {
      question: "Recording கிடைக்குமா?",
      answer: "Yes! Live workshop-ன் recording உங்களுக்கு lifetime access-க்கு கிடைக்கும். Plus bonus materials எல்லாம் download பண்ணிக்கலாம். Recording special request-ல கிடைக்கும்."
    },
    {
      question: "என்ன technical requirements தேவை?",
      answer: "Laptop/mobile + internet connection மட்டும் போதும். AI tools-எல்லாம் browser-ல தான் work ஆகும். Special software install பண்ண தேவையில்லை."
    },
    {
      question: "Money back guarantee இருக்கா?",
      answer: "100% money back guarantee! Workshop attend பண்ணி satisfied இல்லைன்னா 7 days-க்குள் full refund. No questions asked!"
    }
  ];

  // Handle registration button click
  const handleRegistration = () => {
    window.open('https://abdul.cc/10xaipay', '_blank');
  };

  // Sticky Register Button
  const StickyButton = () => (
    <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 z-50">
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={handleRegistration}
        className="bg-gradient-to-r from-orange-500 to-red-600 hover:from-orange-600 hover:to-red-700 text-white font-bold py-3 px-6 sm:py-4 sm:px-8 rounded-full text-sm sm:text-base shadow-2xl flex items-center gap-2 animate-pulse"
      >
        <SafeIcon icon={FiZap} className="w-4 h-4 sm:w-5 sm:h-5" />
        Register Now - Only {seatsLeft} Left!
        <SafeIcon icon={FiArrowRight} className="w-4 h-4 sm:w-5 sm:h-5" />
      </motion.button>
    </div>
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
      {/* Sticky Button */}
      <StickyButton />

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900 via-blue-800 to-indigo-900"></div>
        <div className="absolute inset-0 bg-black/20"></div>
        
        {/* Animated background pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 sm:top-20 left-10 sm:left-20 w-24 sm:w-32 h-24 sm:h-32 bg-orange-500 rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-10 sm:bottom-20 right-10 sm:right-20 w-32 sm:w-40 h-32 sm:h-40 bg-yellow-500 rounded-full blur-3xl animate-pulse delay-1000"></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-40 sm:w-60 h-40 sm:h-60 bg-blue-400 rounded-full blur-3xl animate-pulse delay-500"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="space-y-6 sm:space-y-8"
          >
            {/* Trust badges */}
            <div className="flex flex-wrap justify-center gap-3 sm:gap-6 mb-6 sm:mb-8">
              <div className="bg-white/10 backdrop-blur-sm rounded-full px-3 sm:px-4 py-2 text-white text-xs sm:text-sm font-medium">
                1000+ Students Trained
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-full px-3 sm:px-4 py-2 text-white text-xs sm:text-sm font-medium">
                ₹1 Crore+ Generated
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-full px-3 sm:px-4 py-2 text-white text-xs sm:text-sm font-medium">
                100% Tamil
              </div>
            </div>

            <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white leading-tight">
              <span className="block">3 மணி நேரத்தில்</span>
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-yellow-400">
                AI Master ஆகி
              </span>
              <span className="block">Business-ஐ 10X வளர்த்துக்கொள்ளுங்கள்</span>
            </h1>

            <p className="text-lg sm:text-xl md:text-2xl text-blue-100 max-w-4xl mx-auto leading-relaxed px-4">
              No Coding, No Team, No Big Budget - Just Tamil AI Roadmap
            </p>

            {/* Workshop Schedule */}
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 sm:p-6 max-w-md mx-auto mb-6">
              <div className="flex items-center justify-center gap-2 mb-3">
                <SafeIcon icon={FiCalendar} className="w-5 h-5 text-orange-400" />
                <p className="text-orange-400 font-semibold text-sm sm:text-base">Next Workshop Schedule:</p>
              </div>
              <div className="text-white text-center">
                <div className="text-lg sm:text-xl font-bold">Sunday</div>
                <div className="text-sm sm:text-base text-blue-200">10:00 AM to 1:00 PM IST</div>
                <div className="text-xs sm:text-sm text-blue-300 mt-2">Live Interactive Session</div>
              </div>
            </div>

            {/* Bonus Expiry Timer */}
            <div className="bg-red-500/90 backdrop-blur-sm rounded-2xl p-4 sm:p-6 max-w-sm sm:max-w-md mx-auto border-2 border-red-400">
              <p className="text-white font-semibold mb-4 text-sm sm:text-base">🚨 Bonus Expires In:</p>
              <div className="grid grid-cols-2 gap-2 sm:gap-4 text-center">
                <div className="bg-white/20 rounded-lg p-2 sm:p-3">
                  <div className="text-lg sm:text-2xl font-bold text-white">{bonusTimeLeft.minutes.toString().padStart(2, '0')}</div>
                  <div className="text-xs text-red-200 uppercase">Minutes</div>
                </div>
                <div className="bg-white/20 rounded-lg p-2 sm:p-3">
                  <div className="text-lg sm:text-2xl font-bold text-white">{bonusTimeLeft.seconds.toString().padStart(2, '0')}</div>
                  <div className="text-xs text-red-200 uppercase">Seconds</div>
                </div>
              </div>
              <div className="text-xs text-white/80 mt-2">Don't miss ₹20,000+ worth bonuses!</div>
            </div>

            {/* CTAs */}
            <div className="space-y-4 px-4">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={handleRegistration}
                className="bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-bold py-3 sm:py-4 px-6 sm:px-8 rounded-full text-base sm:text-lg shadow-2xl w-full sm:w-auto"
              >
                இப்போதே Register செய்யுங்கள்
                <SafeIcon icon={FiArrowRight} className="inline ml-2" />
              </motion.button>
              
              <div className="text-white/80 text-sm">
                Only {seatsLeft} Seats Remaining!
              </div>
            </div>

            {/* Guarantee badge */}
            <div className="flex justify-center px-4">
              <div className="bg-green-500/20 border border-green-400 rounded-full px-4 sm:px-6 py-2 text-green-300 text-xs sm:text-sm font-medium">
                <SafeIcon icon={FiShield} className="inline mr-2" />
                100% Money Back Guarantee
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Problem & Solution Section */}
      <section className="py-10 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            {/* Problems */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="space-y-6 sm:space-y-8"
            >
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">
                நீங்கள் இந்த Problems Face பண்றீங்களா?
              </h2>
              
              <div className="space-y-4 sm:space-y-6">
                {[
                  "No leads, no sales - customers எங்க இருக்காங்க?",
                  "Team hire பண்ணறதுக்கு budget இல்லை",
                  "AI tools எல்லாம் English-ல - புரியலை",
                  "YouTube videos பாத்தும் implement பண்ண முடியலை",
                  "Daily same work repeat - burnout ஆயிட்டேன்"
                ].map((problem, index) => (
                  <div key={index} className="flex items-start gap-3 sm:gap-4 p-3 sm:p-4 bg-red-50 rounded-lg">
                    <div className="w-5 sm:w-6 h-5 sm:h-6 bg-red-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                      <span className="text-white text-xs sm:text-sm">✗</span>
                    </div>
                    <p className="text-gray-800 text-sm sm:text-base">{problem}</p>
                  </div>
                ))}
              </div>
            </motion.div>

            {/* Solutions */}
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="space-y-6 sm:space-y-8"
            >
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">
                எல்லாமே Solve ஆகும் - 3 Hours-ல!
              </h2>
              
              <div className="space-y-4 sm:space-y-6">
                {[
                  "24/7 automatic lead generation system",
                  "Ready-made templates (no coding required)",
                  "Tamil AI training (beginner-friendly)",
                  "Step-by-step roadmap with live demo",
                  "Supportive Tamil entrepreneur community"
                ].map((solution, index) => (
                  <div key={index} className="flex items-start gap-3 sm:gap-4 p-3 sm:p-4 bg-green-50 rounded-lg">
                    <div className="w-5 sm:w-6 h-5 sm:h-6 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                      <SafeIcon icon={FiCheck} className="text-white text-xs sm:text-sm" />
                    </div>
                    <p className="text-gray-800 text-sm sm:text-base">{solution}</p>
                  </div>
                ))}
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Social Proof Section */}
      <section className="py-10 sm:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-12 sm:mb-16"
          >
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Real Results from Real Tamil Entrepreneurs
            </h2>
            <p className="text-lg sm:text-xl text-gray-600 px-4">
              2000+ Tamil Entrepreneurs Trained • 95% Students See Results in 30 Days
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {testimonials.map((testimonial, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="bg-white rounded-2xl p-4 sm:p-6 shadow-lg hover:shadow-xl transition-shadow"
              >
                <div className="flex items-center gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <SafeIcon key={i} icon={FiStar} className="w-4 sm:w-5 h-4 sm:h-5 text-yellow-400 fill-current" />
                  ))}
                </div>
                
                <div className="mb-4">
                  <div className="text-xl sm:text-2xl font-bold text-green-600">{testimonial.result}</div>
                  <div className="text-xs sm:text-sm text-gray-500">in {testimonial.period}</div>
                </div>
                
                <blockquote className="text-gray-700 mb-4 italic text-sm sm:text-base">
                  "{testimonial.quote}"
                </blockquote>
                
                <div className="border-t pt-4">
                  <div className="font-semibold text-gray-900 text-sm sm:text-base">{testimonial.name}</div>
                  <div className="text-xs sm:text-sm text-gray-500">{testimonial.role}</div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Curriculum Section */}
      <section className="py-10 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-12 sm:mb-16"
          >
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              3 மணி நேரத்தில் நீங்கள் கற்றுக்கொள்வது
            </h2>
          </motion.div>

          <div className="grid lg:grid-cols-3 gap-6 sm:gap-8">
            {[
              {
                hour: "Hour 1",
                title: "AI Tools Setup & Basic Automation",
                subtitle: "Zero to AI Hero in 60 Minutes",
                icon: FiZap,
                items: ["ChatGPT, Claude, Gemini mastery", "Automation tools setup", "Content generation systems", "Basic workflow creation"]
              },
              {
                hour: "Hour 2", 
                title: "Lead Generation & Sales Funnels",
                subtitle: "Build Your 24/7 Sales Machine",
                icon: FiTarget,
                items: ["AI-powered lead magnets", "Automated email sequences", "Social media automation", "Landing page creation"]
              },
              {
                hour: "Hour 3",
                title: "Scaling & Advanced Strategies", 
                subtitle: "From 1X to 10X Growth Blueprint",
                icon: FiTrendingUp,
                items: ["Advanced AI integrations", "Team automation systems", "Revenue optimization", "Scaling strategies"]
              }
            ].map((module, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.2 }}
                className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-6 sm:p-8 border border-blue-100"
              >
                <div className="text-center mb-6">
                  <div className="w-12 sm:w-16 h-12 sm:h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                    <SafeIcon icon={module.icon} className="w-6 sm:w-8 h-6 sm:h-8 text-white" />
                  </div>
                  <div className="text-xs sm:text-sm font-semibold text-blue-600 mb-2">{module.hour}</div>
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">{module.title}</h3>
                  <p className="text-orange-600 font-medium text-sm sm:text-base">{module.subtitle}</p>
                </div>
                
                <ul className="space-y-3">
                  {module.items.map((item, itemIndex) => (
                    <li key={itemIndex} className="flex items-start gap-3">
                      <SafeIcon icon={FiCheck} className="w-4 sm:w-5 h-4 sm:h-5 text-green-500 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-700 text-sm sm:text-base">{item}</span>
                    </li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </div>

          {/* Learning Outcomes */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mt-12 sm:mt-16 bg-gradient-to-r from-orange-500 to-red-500 rounded-2xl p-6 sm:p-8 text-white text-center"
          >
            <h3 className="text-xl sm:text-2xl font-bold mb-6">By End of Workshop, You'll Have:</h3>
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
              {[
                "Complete AI toolkit setup",
                "Ready-to-use templates",
                "Automated lead system",
                "10X growth roadmap"
              ].map((outcome, index) => (
                <div key={index} className="flex items-center gap-3 bg-white/10 rounded-lg p-3 sm:p-4">
                  <SafeIcon icon={FiCheck} className="w-5 sm:w-6 h-5 sm:h-6 text-yellow-300" />
                  <span className="text-sm sm:text-base">{outcome}</span>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>

      {/* Bonus Section */}
      <section className="py-10 sm:py-20 bg-gradient-to-br from-yellow-50 to-orange-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-12 sm:mb-16"
          >
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              ₹10,000+ Worth Bonuses - Absolutely FREE!
            </h2>
            <div className="text-3xl sm:text-4xl lg:text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-red-500">
              ₹20,000+ Total Value
            </div>
            
            {/* Bonus Timer */}
            <div className="mt-6 bg-red-100 border-2 border-red-300 rounded-xl p-4 max-w-sm mx-auto">
              <p className="text-red-700 font-bold text-sm mb-2">⏰ Bonuses Expire In:</p>
              <div className="grid grid-cols-2 gap-2 text-center">
                <div className="bg-red-500 text-white rounded-lg p-2">
                  <div className="text-lg font-bold">{bonusTimeLeft.minutes.toString().padStart(2, '0')}</div>
                  <div className="text-xs">MIN</div>
                </div>
                <div className="bg-red-500 text-white rounded-lg p-2">
                  <div className="text-lg font-bold">{bonusTimeLeft.seconds.toString().padStart(2, '0')}</div>
                  <div className="text-xs">SEC</div>
                </div>
              </div>
            </div>
          </motion.div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
            {bonuses.map((bonus, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="bg-white rounded-2xl p-4 sm:p-6 shadow-lg hover:shadow-xl transition-all hover:-translate-y-2"
              >
                <div className="text-center">
                  <div className="w-12 sm:w-16 h-12 sm:h-16 bg-gradient-to-r from-orange-500 to-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
                    <SafeIcon icon={bonus.icon} className="w-6 sm:w-8 h-6 sm:h-8 text-white" />
                  </div>
                  
                  <div className="bg-red-500 text-white text-xs sm:text-sm font-bold py-1 px-3 rounded-full inline-block mb-3">
                    Yours FREE
                  </div>
                  
                  <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2">{bonus.title}</h3>
                  <div className="text-xl sm:text-2xl font-bold text-green-600 mb-3">{bonus.value}</div>
                  <p className="text-gray-600 text-xs sm:text-sm">{bonus.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* About Instructor */}
      <section className="py-10 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <div className="relative">
                <div className="w-full h-64 sm:h-80 lg:h-96 rounded-2xl overflow-hidden shadow-2xl">
                  <img 
                    src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1759040594802-Abdul%20Hakkim.webp" 
                    alt="Abdul Hakkim - AI Business Expert"
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                  <div className="w-full h-full bg-gradient-to-br from-blue-100 to-indigo-100 rounded-2xl flex items-center justify-center" style={{display: 'none'}}>
                    <div className="text-center">
                      <div className="w-24 sm:w-32 h-24 sm:h-32 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                        <span className="text-2xl sm:text-4xl font-bold text-white">AH</span>
                      </div>
                      <div className="text-lg sm:text-xl font-bold text-gray-900">Abdul Hakkim</div>
                      <div className="text-gray-600 text-sm sm:text-base">AI Business Expert</div>
                    </div>
                  </div>
                </div>
                
                <div className="absolute -bottom-4 sm:-bottom-6 -right-4 sm:-right-6 bg-yellow-400 rounded-full p-3 sm:p-4">
                  <SafeIcon icon={FiAward} className="w-6 sm:w-8 h-6 sm:h-8 text-yellow-800" />
                </div>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="space-y-6"
            >
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900">
                Meet Your Mentor: Abdul Hakkim
              </h2>
              
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                {[
                  { metric: "₹1 Crore+", label: "Generated Using AI" },
                  { metric: "1000+", label: "Students Trained" },
                  { metric: "2 Years", label: "Zero to AI Expert" }
                ].map((stat, index) => (
                  <div key={index} className="bg-blue-50 rounded-lg p-3 sm:p-4 text-center">
                    <div className="text-lg sm:text-2xl font-bold text-blue-600">{stat.metric}</div>
                    <div className="text-xs sm:text-sm text-gray-600">{stat.label}</div>
                  </div>
                ))}
              </div>

              <div className="space-y-4 text-gray-700 text-sm sm:text-base">
                <p>
                  "2 years ago நானும் ஒரு struggling entrepreneur தான். English AI tools பாத்து 
                  confuse ஆயிட்டு இருந்தேன். But once I cracked the code..."
                </p>
                <p>
                  "இப்போ நான் AI use பண்ணி ₹1 crore+ generate பண்ணியிருக்கேன். அதே strategy-ஐ 
                  1000+ Tamil entrepreneurs-க்கு teach பண்ணி அவங்க life-ஐ transform பண்ணியிருக்கேன்."
                </p>
                <p className="font-semibold text-blue-600">
                  "உங்க business-ஐயும் transform பண்ண ready-ஆ இருக்கேன்!"
                </p>
              </div>

              <div className="flex flex-wrap gap-4">
                <div className="flex items-center gap-2 bg-green-100 rounded-full px-3 sm:px-4 py-2">
                  <SafeIcon icon={FiCheck} className="w-4 sm:w-5 h-4 sm:h-5 text-green-600" />
                  <span className="text-green-800 text-xs sm:text-sm font-medium">Verified Success Story</span>
                </div>
                <div className="flex items-center gap-2 bg-blue-100 rounded-full px-3 sm:px-4 py-2">
                  <SafeIcon icon={FiUsers} className="w-4 sm:w-5 h-4 sm:h-5 text-blue-600" />
                  <span className="text-blue-800 text-xs sm:text-sm font-medium">Community Leader</span>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-10 sm:py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-12 sm:mb-16"
          >
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Frequently Asked Questions
            </h2>
          </motion.div>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="bg-white rounded-lg shadow-sm"
              >
                <button
                  onClick={() => setOpenFaq(openFaq === index ? null : index)}
                  className="w-full px-4 sm:px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50"
                >
                  <span className="font-semibold text-gray-900 text-sm sm:text-base pr-4">{faq.question}</span>
                  <SafeIcon 
                    icon={FiChevronDown} 
                    className={`w-5 h-5 text-gray-500 transition-transform flex-shrink-0 ${
                      openFaq === index ? 'rotate-180' : ''
                    }`} 
                  />
                </button>
                
                <AnimatePresence>
                  {openFaq === index && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                      className="overflow-hidden"
                    >
                      <div className="px-4 sm:px-6 pb-4 text-gray-700 text-sm sm:text-base">
                        {faq.answer}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-10 sm:py-20 bg-gradient-to-br from-blue-900 via-blue-800 to-indigo-900 relative overflow-hidden">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-5 sm:top-10 left-5 sm:left-10 w-24 sm:w-32 h-24 sm:h-32 bg-orange-500 rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-5 sm:bottom-10 right-5 sm:right-10 w-32 sm:w-40 h-32 sm:h-40 bg-yellow-500 rounded-full blur-3xl animate-pulse delay-1000"></div>
        </div>

        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="space-y-6 sm:space-y-8"
          >
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white">
              நீங்கள் Ready-ஆ? Let's Transform Your Business!
            </h2>

            {/* Final Bonus Timer */}
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 sm:p-6 max-w-sm sm:max-w-md mx-auto">
              <p className="text-orange-400 font-semibold mb-4 text-sm sm:text-base">Bonuses Expire In:</p>
              <div className="grid grid-cols-2 gap-2 sm:gap-4 text-center">
                <div className="bg-white/20 rounded-lg p-2 sm:p-3">
                  <div className="text-lg sm:text-2xl font-bold text-white">{bonusTimeLeft.minutes.toString().padStart(2, '0')}</div>
                  <div className="text-xs text-blue-200 uppercase">Minutes</div>
                </div>
                <div className="bg-white/20 rounded-lg p-2 sm:p-3">
                  <div className="text-lg sm:text-2xl font-bold text-white">{bonusTimeLeft.seconds.toString().padStart(2, '0')}</div>
                  <div className="text-xs text-blue-200 uppercase">Seconds</div>
                </div>
              </div>
            </div>

            <div className="space-y-4 px-4">
              <div className="text-red-400 font-bold text-lg sm:text-xl">
                ⚠️ Only {seatsLeft} Seats Remaining!
              </div>

              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={handleRegistration}
                className="bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-bold py-4 sm:py-6 px-8 sm:px-12 rounded-full text-lg sm:text-xl shadow-2xl w-full sm:w-auto"
              >
                My Seat-ஐ Book பண்ணுங்கள்
                <SafeIcon icon={FiArrowRight} className="inline ml-2" />
              </motion.button>

              <div className="flex justify-center">
                <div className="bg-green-500/20 border border-green-400 rounded-full px-4 sm:px-6 py-2 text-green-300 text-xs sm:text-sm font-medium">
                  <SafeIcon icon={FiShield} className="inline mr-2" />
                  Risk-Free - 100% Money Back Guarantee
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8 sm:py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            <div>
              <h3 className="text-lg sm:text-xl font-bold mb-4">10x AI Founder</h3>
              <p className="text-gray-400 text-sm sm:text-base">
                Tamil entrepreneurs-க்கு AI-ன் மூலம் business growth achieve பண்ண உதவுறோம்.
              </p>
            </div>
            
            <div>
              <h4 className="text-base sm:text-lg font-semibold mb-4">Contact</h4>
              <div className="space-y-2 text-gray-400 text-sm sm:text-base">
                <div className="flex items-center gap-2">
                  <SafeIcon icon={FiPhone} className="w-4 h-4" />
                  <span>+91 9884899080</span>
                </div>
                <div className="flex items-center gap-2">
                  <SafeIcon icon={FiMail} className="w-4 h-4" />
                  <span>support@yinguru.com</span>
                </div>
              </div>
            </div>

            <div>
              <h4 className="text-base sm:text-lg font-semibold mb-4">Legal</h4>
              <div className="space-y-2 text-gray-400 text-sm sm:text-base">
                <div><a href="https://funnelsdone.com/terms" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Terms & Conditions</a></div>
                <div><a href="https://funnelsdone.com/privacy" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Privacy Policy</a></div>
                <div><a href="https://funnelsdone.com/refund-policy" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Refund Policy</a></div>
              </div>
            </div>
          </div>
          
          {/* Disclaimer */}
          <div className="border-t border-gray-800 mt-6 sm:mt-8 pt-6 sm:pt-8">
            <div className="text-xs sm:text-sm text-gray-400 leading-relaxed mb-4">
              This site is not a part of the Facebook™ website or Facebook™ Inc. Additionally, This site is NOT endorsed by Facebook™ in any way. FACEBOOK™ is a trademark of FACEBOOK™, Inc. As stipulated by law, we can not and do not make any guarantees about your ability to get results or earn any money with my ideas, information, tools or strategies. I just want to help you by giving great content, direction and strategies that worked well for me and my students and that I believe can help you move forward. All of my terms, privacy policies and disclaimers for this program and website can be accessed via the links. I feel transparency is important and I hold ourselves (you & me) to a high standard of integrity. Thanks for stopping by. I hope this training and content brings you a lot of value & results.
            </div>
            <div className="text-center text-gray-400 text-xs sm:text-sm">
              <p>&copy; 2024 10x AI Founder. All rights reserved.</p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;